import { Component, OnInit } from '@angular/core';
import { IomService } from 'src/app/services/iom.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.css']
})
export class AccessDeniedComponent implements OnInit {

    //  accessDeniedMessageShow: boolean;
  constructor(private iomservice: IomService, private router: Router) { }

  ngOnInit(): void {
    if(this.iomservice.IsAuthorized){
      this.router.navigate(['landing']);
    }
  // this.accessDeniedMessageShow = true;
  }
  

}
